__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-19-1776620462-stable-dev/";